var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-and-hs-template" },
    [
      _c("span", { staticClass: "form-title" }, [
        _vm._v(_vm._s(_vm.$i18.language("设定推荐条件："))),
        _c("span", { staticClass: "form-desc" }, [
          _vm._v(_vm._s(_vm.$i18.language("（关键词与税号对应）"))),
        ]),
      ]),
      _vm._l(_vm.form.interestedProducts, function (item, index) {
        return [
          _c("div", { staticClass: "label-box flex-right" }, [
            _c(
              "span",
              {
                staticClass: "hscode-text auto-trans",
                class: { "is-disabled": _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.hscodeSearch(item)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$i18.language("编码查询")))]
            ),
          ]),
          _c("multiple-prepend", {
            key: index,
            attrs: {
              params: item,
              type: "2",
              className: "allNetKeyWord-input",
              selectIndex: index,
              isPlus: index === 0,
              disabled: _vm.disabled,
              index: index,
            },
            on: {
              loseBlur: (val) => {
                _vm.loseBlur(item, index, val)
              },
              operation: (val) => {
                _vm.operation(index, val)
              },
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }